//import type { RadioProgram } from "@/app/pages/dashRadio/components/types";
export const radioBass = {
  "lunes": [
    {
      id: "bass-001",
      "startTime": "00:00",
      "endTime": "02:00",
      "title": "Chill House",
      "description": "House melódico para quienes siguen despiertos.",
      "color": "#ff6600",
      "src": "https://dl.dropbox.com/scl/fi/z03aphb1k1fndvg5mbl3d/glittertape-8.mp3?rlkey=cx1pf7xlvto1po5ez7vzgh6dp&st=wda36xtg&dl=1",
      "cover": "image/radio/0-2/chill-house/cover.jpg"
    },
    {
      id: "bass-002",
      "startTime": "02:00",
      "endTime": "02:04",
      "title": "El Baño de la Disco",
      "color": "#0059ff",
      "src": "https://dl.dropbox.com/scl/fi/nv8bk5g8z9fqi2xiwbds0/Kloud-VIRUS-Odd-Mob-Remix.mp3?rlkey=71vc7ipouucprsdz3vnqy5f7t&dl=1",
      "cover": "image/disco/virus.jpg"
    },
    {
      id: "bass-003",
      "startTime": "19:04",
      "endTime": "19:36",
      "title": "ID MIX 2025",
      "color": "#ffee00",
      "src": "https://dl.dropbox.com/scl/fi/97avamxl96bcki4xmc0yj/ID-MIX-2025.mp3?rlkey=cz8cj19j1zw1k2s91banwilla&st=jmh838vd&dl=1",
      "cover": "image/radio/bass/id2025.jpg"
    }
  ],
  "martes": [
    {
      id: "bass-005",
      "startTime": "00:00",
      "endTime": "02:00",
      "title": "Chill House",
      "description": "House melódico para quienes siguen despiertos. Todo lo que se quieroda u mas",
      "color": "#ff6600",
      "src": "https://changarrito.es/assets/mus/ab/Ep.008-Reggaeton-2021-Ali-Bhtty.m4a",
      "cover": "image/radio/0-2/chill-house/cover.jpg"
    },
    {
      id: "bass-006",
      "startTime": "16:00",
      "endTime": "18:00",
      "title": "Club Urbano",
      "description": "Reggaeton 2025",
      "color": "#0059ff",
      "src": "https://changarrito.es/assets/mus/ab/Ep.008-Reggaeton-2021-Ali-Bhtty.m4a",
      "cover": "image/set/radioshow/008.jpg"
    }
  ],

  
  "miercoles": [
    {
      id: "bass-008",
      "startTime": "08:25",
      "endTime": "08:45",
      "title": "Chill House",
      "description": "House melódico para quienes siguen despiertos. Todo lo que se quieroda u mas",
      "color": "#ff6600",
      "src": "https://dl.dropbox.com/scl/fi/z03aphb1k1fndvg5mbl3d/glittertape-8.mp3?rlkey=cx1pf7xlvto1po5ez7vzgh6dp&st=wda36xtg&dl=1",
      "cover": "image/radio/0-2/chill-house/cover.jpg"
    },
    {
      "startTime": "09:05",
      "endTime": "09:35",
      "title": "Reggaeton Chile - Dj Luciano",
      "description": "Electrónica amable para empezar el día.",
      "color": "#b1ee9e",
      "src": "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      "cover": "../image/radio/reggaeton/djluciano.jpg"
    },
  ],



  "jueves": [
    {
      "startTime": "01:12",
      "endTime": "01:55",
      "title": "Reggaeton Chile - Dj Luciano",
      "description": "Electrónica amable para empezar el día.",
      "color": "#b1ee9e",
      "src": "https://dl.dropbox.com/scl/fi/uuz3uurg4efic0hympy05/06-Dj-Luciano-Antileo-Reggaeton-Chileno-1.mp3?rlkey=ioig96wx6z6hi2mea93xns1a3&st=dx5q1hcw&dl=1",
      "cover": "../image/radio/reggaeton/djluciano.jpg"
    },
    {
      id: "bass-009",
      "startTime": "03:52",
      "endTime": "04:00",
      "title": "El Baño de la Disco",
      "color": "#0059ff",
      "src": "https://dl.dropbox.com/scl/fi/nv8bk5g8z9fqi2xiwbds0/Kloud-VIRUS-Odd-Mob-Remix.mp3?rlkey=71vc7ipouucprsdz3vnqy5f7t&dl=1",
      "cover": "/image/set/radioshow/008.jpg"
    },
    {
      id: "bass-011",
      "startTime": "06:00",
      "endTime": "07:00",
      "title": "Lo-Fi",
      "description": "Electrónica amable para empezar el día.",
      "color": "#ff6600",
      "src": "https://changarrito.es/assets/mus/ab/Ep.008-Reggaeton-2021-Ali-Bhtty.m4a",
      "cover": "image/set/radioshow/008.jpg"
    }
  ],
  "viernes": [
    {
      id: "bass-015",
      "startTime": "21:30",
      "endTime": "22:00",
      "title": "Glitter Tape 8",
      "color": "#0059ff",
      "src": "https://dl.dropbox.com/scl/fi/z03aphb1k1fndvg5mbl3d/glittertape-8.mp3?rlkey=cx1pf7xlvto1po5ez7vzgh6dp&st=wda36xtg&dl=1",
      "cover": "../image/disco/virus.jpg"
    }
  ],


  "sabado": [
    {
      id: "bass-016",
      "startTime": "00:00",
      "endTime": "02:00",
      "title": "Chill House",
      "description": "House melódico para quienes siguen despiertos. Todo lo que se quieroda u mas",
      "color": "#ff6600",
      "src": "https://dl.dropbox.com/scl/fi/z03aphb1k1fndvg5mbl3d/glittertape-8.mp3?rlkey=cx1pf7xlvto1po5ez7vzgh6dp&st=wda36xtg&dl=1",
      "cover": "image/radio/0-2/chill-house/cover.jpg"
    },
    {
      id: "bass-017",
      "startTime": "19:03",
      "endTime": "19:08",
      "title": "El Baño de la Disco",
      "color": "#0059ff",
      "src": "https://dl.dropbox.com/scl/fi/nv8bk5g8z9fqi2xiwbds0/Kloud-VIRUS-Odd-Mob-Remix.mp3?rlkey=71vc7ipouucprsdz3vnqy5f7t&dl=1",
      "cover": "image/disco/virus.jpg"
    }
  ],


  "domingo": [
    {
      id: "bass-018",
      "startTime": "02:00",
      "endTime": "04:00",
      "title": "El Baño de la Disco",
      "color": "#0059ff",
      "src": "https://dl.dropbox.com/scl/fi/nv8bk5g8z9fqi2xiwbds0/Kloud-VIRUS-Odd-Mob-Remix.mp3?rlkey=71vc7ipouucprsdz3vnqy5f7t&dl=1",
      "cover": "image/disco/virus.jpg"
    },
    {
      id: "bass-019",
      "startTime": "04:00",
      "endTime": "06:00",
      "title": "Silencio",
      "color": "#ff6600",
      "src": "https://changarrito.es/assets/mus/ab/Ep.008-Reggaeton-2021-Ali-Bhtty.m4a",
      "cover": "../image/set/radioshow/008.jpg"
    }
  ]
};